export default __webpack_public_path__ + "static/Difi.io_v3-03-8852557e6a50e5abc869510cd5dc1041.jpg";